import React from 'react';
import { PageContext } from '../context/page-context';

class Hardware extends React.Component {
    render() {
        const {
            image,
            post_title,
            post_content,
            acf: { region }
        } = this.props.block;

        let { geolocation } = this.context;

        if (geolocation === 'Unknown') {
            geolocation = 'ROW';
        }

        if (!region.includes(geolocation)) {
            return null;
        }

        if (this.props.layout && this.props.layout === 'portrait') {
            return (
                <div className="col-sm-4 col-xs-12">
                    <div className="Hardware Hardware--portrait">
                        <img
                            className="img-responsive"
                            src={image}
                            alt={post_title}
                        />
                        <h3 className="Hardware-title">{post_title}</h3>
                        <div
                            className="Hardware-description"
                            dangerouslySetInnerHTML={{ __html: post_content }}
                        />
                    </div>
                </div>
            );
        }

        return (
            <div className="Hardware Hardware--landscape row">
                <div className="col-md-6">
                    <img
                        className="img-responsive"
                        src={image}
                        alt={post_title}
                    />
                </div>
                <div className="col-md-6">
                    <h3 className="Hardware-title">{post_title}</h3>
                    <div
                        className="Hardware-description"
                        dangerouslySetInnerHTML={{ __html: post_content }}
                    />
                </div>
            </div>
        );
    }
}

Hardware.contextType = PageContext;

export default Hardware;
